<template>
  <v-container
    class="mx-0"
    :class="$vuetify.display.xs ? 'dtMainContainerBackgroundMob' : 'dtMainContainerBackground'"
  >
    <LoadingIndicator v-if="updatingDebtData" class="setupLeft" :loading="updatingDebtData" />

    <v-row>
      <!-- My Current Debt Details -->
      <v-col
        cols="12"
        :class="$vuetify.display.xs ? 'myCurrentDebtDetailsMob' : 'myCurrentDebtDetails'"
        class="text-h2"
      >
        {{ $t('L_my_current_debt_details') }}
      </v-col>

      <v-divider />

      <!-- Show the Create Your Plan button -->
      <v-col v-if="isDebtInputHidden">
        <!-- Create Your Plan-->
        <v-row v-if="hasNoPlan">
          <v-col cols="12" class="text-center text-h3">
            <!-- Enter each of your debts -->
            <p>{{ $t('L_enter_each_of_your_debts') }}</p>
            <OnexButton
              role="link"
              color="primary"
              class="max-btn-width my-4"
              @click="openDebtInput"
              :disabled="disablebutton"
            >
              {{ $t('L_create_your_plan') }}
            </OnexButton>
          </v-col>
        </v-row>
        <!-- This is if theres debt data -->
        <template v-else>
          <!-- Header - Paid Off Debts -->
          <v-row>
            <v-col cols="12" class="yourpaidoffdebts">
              {{ $t('L_your_paid_off_debts') }}
            </v-col>
          </v-row>
          <!-- If no debt paid off default message-->
          <v-row v-if="paidOffDebts.length === 0">
            <v-col
              cols="12"
              class="text-center px-2 py-3"
              :class="$vuetify.display.xs ? 'font-size--16' : 'font-size--18'"
            >
              {{ $t('L_as_you_progress_toward_your_goal') }}
            </v-col>
          </v-row>
          <!-- If paid off debts then -->
          <div v-else>
            <v-row
              v-for="(paidOffDebtObject, index) in paidOffDebts"
              :key="index"
              class="paidoffdebt"
            >
              <v-col cols="3" text-center>
                <span><v-img alt="trophy" src="../assets/trophy.svg" /></span>
                <span class="greenText">&nbsp;{{ $t('L_paid_off') }}</span>
              </v-col>
              <v-col
                cols="8"
                class="font-weight-regular linkText"
                @click="openDebtInput(paidOffDebtObject.debtID)"
              >
                {{ paidOffDebtObject.debtName }}
              </v-col>
              <v-col cols="2" text-right pr-3 class="greenText">
                {{ formattedMoney(paidOffDebtObject.minPayment) }}
              </v-col>
            </v-row>
            <v-row pt-4 pb-4>
              <v-col cols="10" pl-4 pr-4>
                {{ $t('L_congratulations_now_that_you_have') }}
              </v-col>
              <v-col cols="2">
                <div class="grayRoundedButtonWBlueText">
                  +${{ getTotalMinPaymentUsinggPaidOffDebts }}
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Header - Current Debts -->
          <v-row>
            <v-col class="currentdebts">
              {{ $t('L_current_debts') }}
            </v-col>
          </v-row>
          <!-- Current Debt for the Desktop view -->
          <div v-if="!$vuetify.display.xs">
            <v-row class="borderOnBottom font-weight-bold py-2">
              <v-col cols="3" class="text-left">
                {{ $t('L_debt_name') }}
              </v-col>
              <v-col cols="3" class="text-right">
                {{ $t('L_pay_off_date') }}
              </v-col>
              <v-col cols="3" class="text-right">
                {{ $t('L_debt_balance') }}
              </v-col>
              <v-col cols="3" class="text-right">
                {{ $t('L_monthly_payment') }}
              </v-col>
            </v-row>
            <v-row
              class="borderOnBottom py-4 text-weight-normal"
              v-for="(item, i) in filteredCurrentDebt"
              :key="i"
            >
              <v-col
                cols="3"
                font-size--16
                text-left
                class="linkText"
                @click="openDebtInput(item.debtId)"
              >
                {{ item.debtName }}
              </v-col>
              <v-col cols="3" class="text-right">
                <!--  {{ getMonthAndYear(projectedPayoffDateGivenDebtId(debtObject.debtID)) }} -->
                {{ getMonthAndYear(item.projectedPayoffDate) }}
              </v-col>
              <v-col cols="3" class="textalignright">
                {{ getDollarAmount(debtBalanceForDebtId(item.debtId)) }}
              </v-col>
              <v-col cols="3" class="textalignright">
                {{ getDollarAmount(debtMonthlyPaymentForDebtId(item.debtId)) }}
              </v-col>
            </v-row>
          </div>
          <!-- Current Debt for the Mobile view -->
          <div v-else>
            <v-row
              class="borderOnBottom py-2 px-4 text-weight-normal"
              v-for="(item, i) in filteredCurrentDebt"
              :key="i"
            >
              <v-col
                cols="12"
                class="linkText text-weight-bold py-2 text-left"
                @click="openDebtInput(item.debtId)"
              >
                {{ item.debtName }}
              </v-col>

              <v-col cols="6" class="text-left text-weight-bold">
                {{ $t('L_pay_off_date') }}
              </v-col>
              <v-col cols="6" class="py-2 font-size--14 text-right">
                <!--  {{ getMonthAndYear(projectedPayoffDateGivenDebtId(debtObject.debtID)) }} -->
                {{ getMonthAndYear(item.projectedPayoffDate) }}
              </v-col>

              <v-col cols="6" class="pt-2 pb-2 font-size--14 text-left text-weight-bold">
                {{ $t('L_debt_balance') }}
              </v-col>
              <v-col cols="6" class="pt-2 pb-2 font-size--14 text-right">
                {{ getDollarAmount(debtBalanceForDebtId(item.debtId)) }}
              </v-col>

              <v-col cols="6" class="py-2 font-size--14 text-lefttext-weight-bold">
                {{ $t('L_monthly_payment') }}
              </v-col>
              <v-col cols="6" class="pt-2 pb-2 font-size--14 text-right">
                {{ getDollarAmount(debtMonthlyPaymentForDebtId(item.debtId)) }}
              </v-col>
            </v-row>
          </div>

          <v-row class="py-0">
            <v-col cols="3" class="px-2 d-flex align-center">
              <v-divider color="#212121" />
            </v-col>
            <v-col cols="6" @click="openDebtInput" class="addadebtlink text-weight-bold">
              <OnexButton class="ma-2" variant="text">
                <v-icon start :icon="mdiPlusCircleOutline" />
                {{ $t('L_add_a_debt') }}
              </OnexButton>
            </v-col>
            <v-col cols="3" class="px-2 d-flex align-center">
              <v-divider color="#212121" />
            </v-col>
          </v-row>
        </template>
      </v-col>
      <!-- Show the input screen -->
      <v-col v-else>
        <MyDebtInput @close-debt-input="onCloseDebtInput" :temp-debt-data="tempObject" />
      </v-col>

      <v-divider />
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions, type PropType } from 'vue';
import MyDebtInput from './MyDebtInput.vue';
import { mapActions, mapState, mapStores } from 'pinia';
import { useDebtSolutionsStore } from '../store/debtsolutions.store';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import { format } from 'date-fns';
import { mdiPlusCircleOutline } from '@mdi/js';
import { useGlobalStore } from '@/stores/global/global.store';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'DebtDetails',
  components: {
    MyDebtInput,
    LoadingIndicator,
    OnexButton,
  },
  props: {
    disablebutton: {
      type: Boolean,
      default: false,
    },
    tpersondob: {
      type: String as PropType<string>,
      default: '',
    },
  },
  data: () => ({
    isDebtInputHidden: true,
    valTotPaidOffMonthlyAmount: 0,
    tempObject: null,
    isDisabledCloseTheDebtInput: false,
    updatingDebtData: false,
    mdiPlusCircleOutline,
  }),
  computed: {
    ...mapStores(useGlobalStore),
    ...mapState(useDebtSolutionsStore, {
      hasNoPlan: 'hasNoPlan',
      debts: 'debts',
      unpaidDebts: 'unpaidDebts',
      paidOffDebts: 'paidOffDebts',
      getTotalMinPaymentUsinggPaidOffDebts: 'getTotalMinPaymentUsinggPaidOffDebts',
      debtGivenDebtId: 'debtGivenDebtId',
      projectedPayoffDateGivenDebtId: 'projectedPayoffDateGivenDebtId',
      debtBalanceForDebtId: 'debtBalanceForDebtId',
      debtMonthlyPaymentForDebtId: 'debtMonthlyPaymentForDebtId',
      step: 'step',
      planWOStacking: 'planWOStacking',
      planWStacking: 'planWStacking',
      addADebtOpen: 'addADebtOpen',
    }),
    filteredCurrentDebt() {
      const tempListToFilter = this.planWOStacking.planItemCollection;
      const paidOffDebtList = this.paidOffDebts;
      if (
        tempListToFilter !== undefined &&
        paidOffDebtList !== undefined &&
        tempListToFilter.length > 0 &&
        paidOffDebtList.length > 0
      ) {
        return tempListToFilter.filter(
          (x: { debtId: string }) =>
            !paidOffDebtList.filter((y: { debtID: string }) => y.debtID === x.debtId).length
        );
      }
      return tempListToFilter;
    },
  },
  mounted() {
    if (this.addADebtOpen === true) {
      this.tempObject = null;
      this.isDebtInputHidden = false;
    }
  },
  methods: {
    ...mapActions(useDebtSolutionsStore, {
      createNewDebt: 'createDebtItem',
      updateDebt: 'updateDebtItem',
      deleteDebt: 'deleteDebtItem',
      debtInit: 'debtInit',
      setAddADebtOpen: 'setAddADebtOpenFlag',
    }),
    getDollarAmount(balance: number | null) {
      if (balance == null || isNaN(balance)) {
        return '';
      }
      return this.$n(balance, 'currency');
    },
    getMonthAndYear(tObj: Date | string | number) {
      const tDate = new Date(tObj);
      const rDate = format(tDate, 'MMM yyyy');
      return rDate;
    },
    getPayOffDate(debtID: string) {
      const val = this.debtGivenDebtId(debtID);
      return val?.projectedPayoffDate;
    },

    async onCloseDebtInput(
      debtData: {
        debtName?: string;
        debtID?: number;
        remove?: boolean;
        [key: string]: unknown;
      } | null
    ) {
      try {
        // Logic for adding / updating done via the
        // this.updateDebtItem(this.debtData); in the DebtInput during submit.
        if (this.isDisabledCloseTheDebtInput) {
          return;
        }
        // Show the Loading spinner
        this.updatingDebtData = true;
        this.isDisabledCloseTheDebtInput = true;
        let response;
        if (debtData?.debtName) {
          if (debtData.remove) {
            response = await this.deleteDebt(debtData, this.tpersondob);
          } else if (debtData.debtID !== undefined && debtData.debtID > -1) {
            response = await this.updateDebt(debtData, this.tpersondob);
          } else {
            response = await this.createNewDebt(debtData, this.tpersondob);
          }
          // this.debtInit();
          if (response) {
            this.updatingDebtData = false;
          }
        } else {
          this.updatingDebtData = false;
        }
        setTimeout(() => {
          this.isDisabledCloseTheDebtInput = false;
        }, 500);
        this.isDebtInputHidden = true;
        this.setAddADebtOpen(false);
        this.$emit('is-debt-input-hidden', true);
      } catch (e) {
        this.globalStore.addError({ error: e, context: 'DebtDetails onCloseDebtInput' });
        this.isDisabledCloseTheDebtInput = false; // This allows to close Debt Input
        this.updatingDebtData = false; // Hide the modal spinner
        this.isDebtInputHidden = true; // Hide the Debt Input
        this.$emit('is-debt-input-hidden', true);
      }
    },
    openDebtInput(debtId: string) {
      if (typeof debtId === 'string' || typeof debtId === 'number') {
        this.tempObject = JSON.parse(JSON.stringify(this.debtGivenDebtId(debtId)));
      } else {
        this.tempObject = null;
      }
      this.isDebtInputHidden = false;
      this.$emit('is-debt-input-hidden', false);
    },
    getDebtBalance(debtObject: { balance: number } | null | undefined) {
      return debtObject !== undefined ? this.$n(debtObject?.balance, 'currency', 'en-US') : '';
    },
    getMontlyPayment(debtObject: { minPayment: number } | null | undefined) {
      return debtObject !== undefined ? this.$n(debtObject?.minPayment, 'currency', 'en-US') : '';
    },
    formattedMoney(strMoney: number | string | undefined | null) {
      return strMoney !== undefined ? this.$n(strMoney, 'currency', 'en-US') : '';
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.dtMainContainerBackground {
  background-color: #ffffff;
}
.dtMainContainerBackgroundMob {
  background-color: #ffffff;
}
.max-btn-width {
  max-width: 260px;
  width: 260px;
}
.addadebtlink {
  color: #02579e;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.circleplus {
  border: solid 2px #02579e;
  border-radius: 18px;
  padding: 0 3px 0 3px;
  margin-right: 8px;
}
.borderOnBottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.currentdebts,
.yourpaidoffdebts {
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  background-color: #f5f5f5;
  font-size: 20px;
  line-height: 2.9;
  text-align: center;
}
.asyouprogress {
  background-color: #ffffff;
  font-size: 14px;
  height: 76px;
  line-height: 76px;
  text-align: center;
}
.textalignright {
  text-align: right;
}
.paidoffdebt {
  height: 50px;
  line-height: 50px;
  background-color: #eafbec;
  font-weight: 600;
}
.linkText {
  color: #02579e;
  cursor: pointer;
}
.greenText {
  color: #098d1f;
}
.grayRoundedButtonWBlueText {
  background-color: #eeeeee;
  color: #063562;
  border-radius: 16px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin-top: 20px;
  font-weight: 600;
}
.enterEachOfYourDebt {
  font-size: 20px;
  color: #333333;
  padding-top: 20px;
}
.enterEachOfYourDebtMob {
  font-size: 20px;
  color: #333333;
  padding-top: 20px;
}
.setupLeft {
  margin-left: -24px;
}
.loading-indicator {
  z-index: 10 !important;
}
.disabledBtn {
  background-color: #eee !important;
}
.myCurrentDebtDetails {
  padding: 24px 0 24px 0;
}
.myCurrentDebtDetailsMob {
  text-align: center;
  padding: 12px 0 12px 0;
}
</style>
